import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { FiPlus } from "react-icons/fi";
import { FiMoreVertical } from "react-icons/fi";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { MdDeleteOutline } from "react-icons/md";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../validation/validationConstant";
import {
  updateEducationJobseeker,
  deleteEducationJobseeker,
} from "../service/apis/auth.api";
import { updateEducation } from "../store/auth.store";
import { showError, showSuccess } from "../utils/Common";

const EducationalDetailsScreen = () => {
  const dispatch = useDispatch();
  const [editingEducationId, setEditingEducationId] = useState<string | null>(
    null
  );

  const [showEducation, setShowEducation] = useState(false);
  const handleCloseED = () => {
    setShowEducation(false);
    setEditingEducationId(null);
  };
  const handleShowED = () => {
    setShowEducation(true);
    setEditingEducationId(null);
  };

  const [showEditEducation, setShowEditEducation] = useState(false);
  const handleCloseEditED = () => {
    setShowEditEducation(false);
  };

  const { user } = useSelector((state: RootState) => state.authSlice);

  const educationalProfileik = useFormik({
    initialValues: {
      from: "",
      to: "",
      stream: "",
      institution: "",
    },
    validationSchema: yup.object({
      from: yup
        .date()
        .nullable()
        .required(ValidationCons.EDU_FROM_REQUIRED)
        .max(yup.ref("to"), "From date cannot be after To date")
        .test(
          "not-same",
          "From date and To date cannot be the same",
          function (value) {
            const toDate: string = this.resolve(yup.ref("to"));
            const formattedFormDate = new Date(value)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            const formattedToDate = new Date(toDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            return formattedFormDate !== formattedToDate; // Ensure the two dates are not the same
          }
        ),
      to: yup
        .date()
        .nullable()
        .required(ValidationCons.EDU_TO_REQUIRED)
        .min(yup.ref("from"), "End date cannot be before From date")
        .test(
          "not-same",
          "From date and To date cannot be the same",
          function (value) {
            const fromDate: string = this.resolve(yup.ref("from"));
            const formattedFormDate = new Date(fromDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            const formattedToDate = new Date(value)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");

            return formattedToDate !== formattedFormDate; // Ensure the two dates are not the same
          }
        ),
      stream: yup.string().trim().required(ValidationCons.EDU_STREAM_REQUIRED),
      institution: yup
        .string()
        .trim()
        .required(ValidationCons.EDU_SCHOOL_REQUIRED),
    }),
    onSubmit: async (values: any, { resetForm }) => {
      // setLoading(true);
      // console.log(222);

      try {
        let bodyData = {
          from: values.from,
          to: values.to,
          stream: values.stream,
          institution: values.institution,
        };

        const response = await updateEducationJobseeker(bodyData, "education");
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseED();
            let updatedEducation = response.data;

            dispatch(updateEducation(updatedEducation));
            showSuccess("Educational Info Updated successfully");
            resetForm();
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error.message);
      }
    },
  });

  const educationalEditProfileik = useFormik({
    initialValues: {
      from: "",
      to: "",
      stream: "",
      institution: "",
    },
    validationSchema: yup.object({
      from: yup
        .date()
        .nullable()
        .required(ValidationCons.EDU_FROM_REQUIRED)
        .max(yup.ref("to"), "From date cannot be after To date")
        .test(
          "not-same",
          "From date and To date cannot be the same",
          function (value) {
            const toDate: string = this.resolve(yup.ref("to"));
            const formattedFormDate = new Date(value)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            const formattedToDate = new Date(toDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            return formattedFormDate !== formattedToDate; // Ensure the two dates are not the same
          }
        ),
      to: yup
        .date()
        .nullable()
        .required(ValidationCons.EDU_TO_REQUIRED)
        .min(yup.ref("from"), "End date cannot be before From date")
        .test(
          "not-same",
          "From date and To date cannot be the same",
          function (value) {
            const fromDate: string = this.resolve(yup.ref("from"));
            const formattedFormDate = new Date(fromDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");
            const formattedToDate = new Date(value)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "/");

            return formattedToDate !== formattedFormDate; // Ensure the two dates are not the same
          }
        ),
      stream: yup.string().trim().required(ValidationCons.EDU_STREAM_REQUIRED),
      institution: yup
        .string()
        .trim()
        .required(ValidationCons.EDU_SCHOOL_REQUIRED),
    }),
    onSubmit: async (values: any, { resetForm }) => {
      // setLoading(true);
      // console.log(222);

      try {
        let bodyData = {
          _id: editingEducationId,
          from: values.from,
          to: values.to,
          stream: values.stream,
          institution: values.institution,
        };

        const response = await updateEducationJobseeker(bodyData, "education");
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseEditED();
            // dispatch(setUser(response.user));
            let updatedEducation = response.data;
            dispatch(updateEducation(updatedEducation));
            showSuccess("Educational Info Updated successfully");
            resetForm();
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error?.message);
      }
    },
  });

  const getYearFromDate = (dateString: string): number => {
    const date = new Date(dateString);
    return date.getUTCFullYear(); // or date.getFullYear() if local timezone is acceptable
  };

  function getOnlyDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const editingEducation = (expId: string) => {
    setEditingEducationId(expId);

    const editEducationData: any = user?.education.filter(
      (item) => item?._id === expId
    );
    educationalEditProfileik.setValues({
      from: getOnlyDate(editEducationData[0].from),
      to: getOnlyDate(editEducationData[0].to),
      stream: editEducationData[0].stream,
      institution: editEducationData[0].institution,
    });
    setShowEditEducation(true);
  };

  const deleteEducation = (expId: string) => {
    const editEducationData: any = user?.education.filter(
      (item) => item?._id !== expId
    );
    deleteEducationJobseeker(expId, "education");
    dispatch(updateEducation(editEducationData));
  };
  return (
    <>
      <div className="comnbrdrGap profileEdit mb-4">
        <div className="d-flex">
          <h3>My Education</h3>
          <button className="editbtn" onClick={handleShowED}>
            <FiPlus /> Add
          </button>
        </div>
        {user?.education &&
          user?.education?.map((edu: any) => (
            <div className="moreedit-holder" key={edu?._id}>
              <div className="d-flex">
                <h6>
                  {getYearFromDate(edu?.from)}-{getYearFromDate(edu?.to)}
                </h6>
                <Dropdown as={NavItem} className="editnow">
                  <Dropdown.Toggle className="profiledropdown" as={NavLink}>
                    <FiMoreVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      className=""
                      onClick={() => {
                        editingEducation(edu?._id);
                      }}
                    >
                      <LuPencilLine /> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        deleteEducation(edu?._id);
                      }}
                    >
                      <MdDeleteOutline /> Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <h6>
                {edu?.stream} - <span>{edu?.institution}</span>
              </h6>
            </div>
          ))}
      </div>

      {/* Add Education Information model*/}
      <Modal
        show={showEducation}
        onHide={handleCloseED}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Add Education Information</h3>
            <Form
              className="modalSearch"
              onSubmit={educationalProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Starting date"
                  name="from"
                  onChange={educationalProfileik.handleChange}
                  onBlur={educationalProfileik.handleBlur}
                  value={educationalProfileik.values.from}
                  isInvalid={
                    !!educationalProfileik.errors.from &&
                    Boolean(educationalProfileik.touched.from)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalProfileik.errors.from === "string" &&
                    educationalProfileik.errors.from}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Ending date"
                  name="to"
                  onChange={educationalProfileik.handleChange}
                  onBlur={educationalProfileik.handleBlur}
                  value={educationalProfileik.values.to}
                  isInvalid={
                    !!educationalProfileik.errors.to &&
                    Boolean(educationalProfileik.touched.to)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalProfileik.errors.to === "string" &&
                    educationalProfileik.errors.to}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Field of Study</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your field of study"
                  name="stream"
                  onChange={educationalProfileik.handleChange}
                  onBlur={educationalProfileik.handleBlur}
                  value={educationalProfileik.values.stream}
                  isInvalid={
                    !!educationalProfileik.errors.stream &&
                    Boolean(educationalProfileik.touched.stream)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalProfileik.errors.stream === "string" &&
                    educationalProfileik.errors.stream}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>School/College Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your school name"
                  name="institution"
                  onChange={educationalProfileik.handleChange}
                  onBlur={educationalProfileik.handleBlur}
                  value={educationalProfileik.values.institution}
                  isInvalid={
                    !!educationalProfileik.errors.institution &&
                    Boolean(educationalProfileik.touched.institution)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalProfileik.errors.institution ===
                    "string" && educationalProfileik.errors.institution}
                </Form.Control.Feedback>
              </Form.Group>
              <Button className="btn w-100" type="submit">
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Edit Education*/}
      <Modal
        show={showEditEducation}
        onHide={handleCloseEditED}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Edit Education Information</h3>
            <Form
              className="modalSearch"
              onSubmit={educationalEditProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Starting date"
                  name="from"
                  onChange={educationalEditProfileik.handleChange}
                  onBlur={educationalEditProfileik.handleBlur}
                  value={educationalEditProfileik.values.from}
                  isInvalid={
                    !!educationalEditProfileik.errors.from &&
                    Boolean(educationalEditProfileik.touched.from)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalEditProfileik.errors.from === "string" &&
                    educationalEditProfileik.errors.from}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Ending date"
                  name="to"
                  onChange={educationalEditProfileik.handleChange}
                  onBlur={educationalEditProfileik.handleBlur}
                  value={educationalEditProfileik.values.to}
                  isInvalid={
                    !!educationalEditProfileik.errors.to &&
                    Boolean(educationalEditProfileik.touched.to)
                  }
                  max={new Date().toISOString().split("T")[0]} // Sets the max date to today
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalEditProfileik.errors.to === "string" &&
                    educationalEditProfileik.errors.to}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Field of Study</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your field of study"
                  name="stream"
                  onChange={educationalEditProfileik.handleChange}
                  onBlur={educationalEditProfileik.handleBlur}
                  value={educationalEditProfileik.values.stream}
                  isInvalid={
                    !!educationalEditProfileik.errors.stream &&
                    Boolean(educationalEditProfileik.touched.stream)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalEditProfileik.errors.stream === "string" &&
                    educationalEditProfileik.errors.stream}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>School/College Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your school name"
                  name="institution"
                  onChange={educationalEditProfileik.handleChange}
                  onBlur={educationalEditProfileik.handleBlur}
                  value={educationalEditProfileik.values.institution}
                  isInvalid={
                    !!educationalEditProfileik.errors.institution &&
                    Boolean(educationalEditProfileik.touched.institution)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof educationalEditProfileik.errors.institution ===
                    "string" && educationalEditProfileik.errors.institution}
                </Form.Control.Feedback>
              </Form.Group>
              <Button className="btn w-100" type="submit">
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Add Education Information model*/}
    </>
  );
};
export default EducationalDetailsScreen;
